var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.876,
    height: 73.489,
    viewBox: "0 0 53.876 73.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10154",
    "data-name": "Grupo 10154",
    transform: "translate(-3606.93 -3365.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7117",
    "data-name": "Trazado 7117",
    d: "M460.2,31.025a.986.986,0,0,1,.025.379V31.27a1.667,1.667,0,0,0-.025-.245ZM447.49,18.006a1.243,1.243,0,0,0-.624-.331A1.343,1.343,0,0,1,447.49,18.006Z",
    transform: "translate(3200.571 3347.861)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7118",
    "data-name": "Trazado 7118",
    d: "M211.344,30.874a1.24,1.24,0,0,0-.33-.625L198.63,17.855a.983.983,0,0,0-.294-.208,1.073,1.073,0,0,0-.331-.122,1.517,1.517,0,0,0-.233-.025H158.725a1.225,1.225,0,0,0-1.225,1.225v71.04a1.225,1.225,0,0,0,1.225,1.225h51.417a1.225,1.225,0,0,0,1.225-1.225V31.119a1.676,1.676,0,0,0-.025-.245ZM199,21.688l8.218,8.231H199Zm9.921,66.85H159.951V19.948h36.6v11.2a1.225,1.225,0,0,0,1.225,1.225h11.146Z",
    transform: "translate(3449.43 3348.012)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7119",
    "data-name": "Trazado 7119",
    d: "M286.4,214.674l-6.369-6.369a9.617,9.617,0,0,0,2.07-6,9.8,9.8,0,1,0-9.8,9.8,9.616,9.616,0,0,0,6-2.07l6.369,6.369a1.173,1.173,0,0,0,.857.355,1.2,1.2,0,0,0,.869-.355A1.224,1.224,0,0,0,286.4,214.674ZM267.1,207.5a7.333,7.333,0,1,1,5.193,2.156A7.335,7.335,0,0,1,267.1,207.5Z",
    transform: "translate(3359.129 3197.503)",
    fill: "#b1ca56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e7f53c24c5cb6b3ef072765d603e3a58.svg";
export { ForwardRef as ReactComponent };